import { toast } from "react-toastify";
import { LoginDto } from "../types/Auth";
import { api } from "./api";

export const authService = {
  login: async (data: LoginDto) => {
    try {
      const result = await api.post("/auth/login", data);
      return result;
    } catch (error: any) {
      console.error(
        `Login error: ${error.response?.data?.message || error.message}`
      );
      return null;
    }
  },

  refresh: async () => {
    try {
      var data = await api.post("/auth/refresh");
      return data;
    } catch (error: any) {
      console.error(
        `Token refresn error: ${error.response?.data?.message || error.message}`
      );
      toast.error("Could not refresh session.");
    }
  },

  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch (error: any) {
      console.error(
        `Token refresn error: ${error.response?.data?.message || error.message}`
      );
      toast.error("Failed to logout.");
      return false;
    }
  },
};
